import classNames from "classnames";
import Nbsp from "../../../../utils/nbsp";
import { isMobileView } from "../../appStates/appStates";

interface IAvisValueRowProps {
  title?: string;
  value?: string | JSX.Element;
}
export function AvisField(props: Readonly<IAvisValueRowProps>) {
  const { title, value } = props;

  const classNameContainerCol = isMobileView.value ? "col-12" : "col-4";
  const classNameContainer = classNames(
    "avis-field-container",
    "grid",
    classNameContainerCol,
  );

  return (
    <div className={classNameContainer}>
      <div className="avis-field-title col-12">{title}</div>
      <div className="avis-field-value col-12">{value ? value : <Nbsp />}</div>
    </div>
  );
}
